import { ApolloLink, from } from '@apollo/client'
import authLink from './auth.link'
import errorLink from './error.link'
import directionalLink from './directional.link'
import loggerLink from './logger.link'
import { RetryLink } from '@apollo/client/link/retry'

const retryIf = (error, operation) => {
  const doNotRetryCodes = [500, 400]
  return !!error && !doNotRetryCodes.includes(error.statusCode)
}

const retryLink = new RetryLink({
  delay: {
    initial: 100,
    max: 2000,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf,
  },
})

// NOTE : Here links sequence are important
// Please modify carefully
const additiveLink = from([
  loggerLink,
  authLink,
  retryLink,
  errorLink,
  directionalLink, // subscription + http => should be always terminal link
])

export default additiveLink
